import {post} from "./base";
import { statusRichiesta } from "../config/config";
import { Order } from "../models/order";

export async function getAll(accessToken) {
    const data = await post("richieste/GetRichieste", { jsonBody: { accessToken } });
    if (!Array.isArray(data)) return [];
    return data.map((item) => new Order(item));
}

export function parseStatus(status) {
    /*
    export const statusRichiesta = {
    inAttesa: 0,
    inevaso: 1, // pronto per essere ritirato o spedito
    evaso: 2, // ordine ritirato o spedito
    rifiutato: 3, // cancellato da agente o rifiutato da magazziniere
    approvato: 4, // in caso sia per una vendita (approvata dall'admin)
    };
    */
    switch(parseInt(status,10)) {
        
        case statusRichiesta.inAttesa:
            return "ricevuto";
        case statusRichiesta.inevaso:
            return "visualizzato";
        case statusRichiesta.evaso:
            return "evaso";
        case statusRichiesta.rifiutato:
            return "rifiutato";
        case statusRichiesta.approvato:
            return "approvato";
        default:
            return "sconosciuto";
    }
}

//Crea un lastOrder a partire dallo stato dell'ultimo ordine recuperando gli ordini con getAll
export async function retrieveLastActiveOrder(accessToken) {
    var orders = await getAll(accessToken);
    orders = orders.filter((order) => parseInt(order.status,10) !== statusRichiesta.rifiutato);
    orders = JSON.parse(JSON.stringify(orders));
    var lastOrder = orders[orders.length - 1] || {};
    lastOrder = {...lastOrder, statusText: parseStatus(lastOrder.status)};
    return lastOrder;
}

//Crea un lastOrder a partire dallo stato dell'ultimo ordine recuperando gli ordini con getAll
export async function retrieveLastRejectedOrder(accessToken) {
    var orders = await getAll(accessToken);
    orders = orders.filter((order) => parseInt(order.status,10) === statusRichiesta.rifiutato);
    orders = JSON.parse(JSON.stringify(orders));
    var lastOrder = orders[orders.length - 1] || {};
    lastOrder = {...lastOrder, statusText: parseStatus(lastOrder.status)};
    return lastOrder;
}



export async function add(accessToken, data) {
    // extra, cart
    await post("richieste/AddRichiesta", {jsonBody: {...data, accessToken }});
    console.log(`Richiesta campioni added`);
}

export async function update(accessToken, idRichiesta, status) {
    await post("richieste/UpdateStatusRichiesta", {jsonBody: {
        accessToken,
        idRichiesta,
        status
    }});
    console.log(`Richiesta campioni ${idRichiesta} updated with state ${Object.keys(statusRichiesta).find((k) => statusRichiesta[k] === status)}`);
}

export async function extra(accessToken, idRichiesta, extra) {
    await post("richieste/UpdateOrder", {jsonBody: {
        accessToken,
        idRichiesta,
        extra,
        updateType: 'extra',
    }});
    console.log(`Richiesta campioni ${idRichiesta} set as ${extra ? 'extra' : 'regular'}`);
}

export async function addToCart(accessToken, idRichiesta, idCampione, quantity) {
    await post("richieste/UpdateOrder", {jsonBody: {
        accessToken,
        idRichiesta,
        idCampione,
        quantity,
        updateType: 'add',
    }});
    console.log(`Campione ${idCampione} added to richiesta ${idRichiesta}`);
}

export async function updateCartQuantity(accessToken, idRichiesta, idCampione, quantity) {
    await post("richieste/UpdateOrder", {jsonBody: {
        accessToken,
        idRichiesta,
        idCampione,
        quantity,
        updateType: 'quantity',
    }});
    console.log(`Richiesta campioni ${idRichiesta} cart quantity updated for campione ${idCampione}`);
}

export async function removeFromCart(accessToken, idRichiesta, idCampione) {
    await post("richieste/UpdateOrder", {jsonBody: {
        accessToken,
        idRichiesta,
        idCampione,
        updateType: 'delete',
    }});
    console.log(`Richiesta campioni ${idRichiesta} got campione ${idCampione} removed from cart`);
}
